import * as Actions from "./actions";
import { ROLES } from "@app/constants";
import { trackEvent, setUser, analiticsReset, setUserPropertyOnce, setUserPropertyIncrement } from "@amplio-common/analytics";
import * as Sentry from "@sentry/browser";
import { SSO_ERROR_MESSAGE } from "./constants";

const initialState = {
  user: {
    isLoading: false,
    isAuthenticated: false,
    isVerified: false,
  },
  login: {
    isLoading: false,
  },
  providerLogin: {
    isProviderLoading: true,
  },
  password: {
    isLoading: false,
  },
  password_reset: {
    isLoading: false,
  },
  register: {
    isLoading: false,
  },
};

const auth = (state = initialState, action) => {
  switch (action.type) {
    case Actions.USER.REQUEST:
      return { ...state, user: { ...state.user, isLoading: true } };
    case Actions.USER.SUCCESS:
      return { ...state,
        user: { ...state.user,
          ...action.payload.user,
          isAuthenticated: true,
          isVerified: true,
          isLoading: false,
          errors: null } };
    case Actions.USER.FAILURE:
      localStorage.clear();
      window.location.reload();
      return { ...state, user: { ...state.user, errors: action.payload.data, isLoading: false } };

    case Actions.LOGIN.REQUEST:
      return { ...state,
        login: { ...state.login, isLoading: true },
        user: { ...state.user, isAuthenticated: false, isVerified: false } };
    case Actions.PROVIDER_LOGIN.REQUEST:
      return { ...state,
        login: { ...state.login, isLoading: true },
        user: { ...state.user, isAuthenticated: false, isVerified: false },
        providerLogin: {
          isProviderLoading: true,
        },
      };
    case Actions.PROVIDER_LOGIN.SUCCESS: {
      const entry_types = { google: "google", clever: "SSO_Amplio_to_Clever" };
      trackEvent("new_login", { entry_type: entry_types[action.payload.provider], user_role: action.payload.role });
      setUser(action.payload.id);
      return { ...state,
        login: { ...state.login, isLoading: false, errors: null },
        user: {
          ...state.user,
          isAuthenticated: true,
          isVerified: true, // students are auto-verified
          otpUrl: action.payload.otpUrl,
        },
        providerLogin: {
          isProviderLoading: false },
      };
    }
    case Actions.LOGIN.SUCCESS:
      setUser(action.payload.id);
      Sentry.setUser({ id: action.payload.id });
      setUserPropertyOnce("first_login", new Date());
      setUserPropertyIncrement("number_of_logins");
      trackEvent("new_login", { entry_type: "username", user_role: action.payload.role });
      return { ...state,
        login: { ...state.login, isLoading: false, errors: null },
        user: { ...state.user,
          isAuthenticated: true,
          isVerified: (action && action.payload && action.payload.role === ROLES.STUDENT.id) && (action && action.payload), // students are auto-verified only if not belongs to clalit
          otpUrl: action.payload.otpUrl,
          username: action.payload.username } };
    case Actions.PROVIDER_LOGIN.FAILURE: {
      const err = action.payload.error.non_field_errors;
      trackEvent("login_error_shown", { error_type: err && err[0], provider_name: action.payload.provider });
      setUser(undefined);
      return { ...state,
        login: { ...state.login,
          isLoading: false,
          errors: [SSO_ERROR_MESSAGE],
        },
        user: { ...state.user, isAuthenticated: false, isVerified: false },
        providerLogin: {
          isProviderLoading: false,
        },
      };
    }
    case Actions.LOGIN.FAILURE: {
      trackEvent("login_error_shown", { error_type: "password" });
      setUser(undefined);
      return { ...state,
        login: { ...state.login,
          isLoading: false,
          errors: action.payload.non_field_errors || [action.payload.detail],
        },
        user: { ...state.user, isAuthenticated: false, isVerified: false } };
    }
    case Actions.CODE_LOGIN.REQUEST:
      return { ...state,
        login: { ...state.login, isLoading: true },
        user: { ...state.user, isAuthenticated: false, isVerified: false } };
    case Actions.CODE_LOGIN.SUCCESS:
      setUser(action.payload.id);
      Sentry.configureScope(scope => scope.setUser(null));
      setUserPropertyOnce("first_login", new Date());
      setUserPropertyIncrement("number_of_logins");
      localStorage.removeItem("token");
      trackEvent("new_login", { entry_type: window.location.href.includes("/code") ? "link" : "code", user_role: ROLES.STUDENT.id });
      return { ...state,
        login: { ...state.login, isLoading: false, errors: null },
        user: {
          ...state.user,
          isAuthenticated: !action.payload.is_email_required,
          isVerified: !action.payload.is_email_required && !action.payload.is_otp_required,
          isEmailRequired: action.payload.is_email_required,
          is_otp_required: action.payload.is_otp_required,
          otpUrl: action.payload.otpUrl,
          message: action.payload.message,
        } };
    case Actions.CODE_LOGIN.FAILURE:
      trackEvent("login_error_shown", { error_type: window.location.href.includes("/code") ? "link" : "code" });
      setUser(undefined);
      Sentry.configureScope(scope => scope.setUser(null));
      return { ...state,
        login: { ...state.login,
          isLoading: false,
          errors:
                    action.payload.non_field_errors },
        user: { ...state.user, isAuthenticated: false, isVerified: false } };

    case Actions.LOGIN_VALUE.REQUEST:
      return { ...state,
        login: { ...state.login, isLoading: true },
        user: { ...state.user, isAuthenticated: false, isVerified: false } };
    case Actions.LOGIN_VALUE.SUCCESS:
      setUser(action.payload.id);
      Sentry.configureScope(scope => scope.setUser(null));
      setUserPropertyOnce("first_login", new Date());
      setUserPropertyIncrement("number_of_logins");
      trackEvent("new_login", { entry_type: "class_code", user_role: ROLES.STUDENT.id });
      return { ...state,
        login: { ...state.login, isLoading: false, errors: null },
        user: { ...state.user,
          isAuthenticated: true,
          isVerified: true, // students are auto-verified
          otpUrl: action.payload.otpUrl } };
    case Actions.LOGIN_VALUE.FAILURE:
      setUser(undefined);
      Sentry.configureScope(scope => scope.setUser(null));
      trackEvent("login_error_shown", { error_type: action.payload?.non_field_errors[0]?.includes("scheduled") ? "wrong_date" : "full_name" });
      return { ...state,
        login: { ...state.login,
          isLoading: false,
          errors:
                        action.payload.non_field_errors },
        user: { ...state.user, isAuthenticated: false, isVerified: false } };

    case Actions.LOGIN_OTP.REQUEST:
      trackEvent("OTP_submit");
      return { ...state,
        user: { ...state.user, isVerified: false },
        login: { ...state.login, isLoading: true },
      };
    case Actions.LOGIN_OTP.SUCCESS:
      return { ...state,
        login: { ...state.login, isLoading: false, errors: null, show: false },
        user: { ...state.user, isVerified: true } };
    case Actions.LOGIN_OTP.FAILURE:
      return { ...state,
        login: { ...state.login, isLoading: false, errors: action.payload.data || ["Wrong Code, Please Try Again"] },
        user: { ...state.user, isVerified: false } };

    case Actions.LOGIN_STUDENT_OTP.REQUEST:
      trackEvent("OTP_submit");
      return { ...state,
        user: { ...state.user, isVerified: false },
        login: { ...state.login, isLoading: true },
      };
    case Actions.LOGIN_STUDENT_OTP.SUCCESS:
      return { ...state,
        login: { ...state.login, isLoading: false, errors: null, show: false },
        user: { ...state.user, isVerified: true } };
    case Actions.LOGIN_STUDENT_OTP.FAILURE:
      return { ...state,
        login: { ...state.login, isLoading: false, errors: action.payload.data || ["Wrong Code, Please Try Again"] },
        user: { ...state.user, isVerified: false } };

    case Actions.LOGOUT.REQUEST:
      trackEvent("logout");
      setUser(null); analiticsReset();
      Sentry.configureScope(scope => scope.setUser(null));
      return { ...state, logout: { isLoading: true } };

    case Actions.PASSWORD.REQUEST:
      return { ...state, password: { isLoading: true } };
    case Actions.PASSWORD.SUCCESS:
      return { ...state, password: { isLoading: false } };
    case Actions.PASSWORD.FAILURE:
      return { ...state, password: { isLoading: false, errors: action.payload.email } };

    case Actions.REGISTER.REQUEST:
      return { ...state, register: { isLoading: true } };
    case Actions.REGISTER.SUCCESS:
      return { ...state, register: { isLoading: false } };
    case Actions.REGISTER.FAILURE:
      return { ...state, register: { isLoading: false } };

    case Actions.PASSWORD_RESET.REQUEST:
      return { ...state, password_reset: { isLoading: true, errors: null } };
    case Actions.PASSWORD_RESET.SUCCESS:
      return { ...state, password_reset: { isLoading: false, errors: null } };
    case Actions.PASSWORD_RESET.FAILURE:
      return { ...state,
        password_reset:
            {
              isLoading: false,
              errors: (action.payload.new_password ? action.payload.new_password : [])
                .concat((action.payload.non_field_errors ? action.payload.non_field_errors : [])),
            } };
    // case
    default:
      return state;
  }
};

export default auth;
